import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// Rxjs dependencies.
import { Subject } from 'rxjs';

const PROMO_GIF_SRC = require('./assets/promo.gif');

@Component({
    templateUrl: './arena.component.pug',
    styleUrls: ['./arena.component.less']
})
export class ArenaComponent implements OnInit, OnDestroy {
  private readonly _destroySbj = new Subject<void>();

  protected readonly PROMO_GIF_SRC = PROMO_GIF_SRC;

  protected accessData: any = {};

  constructor(
    private _route: ActivatedRoute
  ) {
    // Noop.
  }

  public ngOnInit(): void {
    this.accessData = this._route.snapshot.data['accessData'];
  }

  public ngOnDestroy(): void {
    this._destroySbj.next();
    this._destroySbj.complete();
  }
}
